import { planDisplayName } from './planDisplay'

export const PLAN_FEATURE_CATEGORY_LABELS = {
  'Ordering & Operations': { icon: '🛒', label: 'Ordering' },
  'Invoice & Reporting': { icon: '📄', label: 'Invoices' },
  'Menu Builder & Recipes': { icon: '🧑‍🍳', label: 'Menu Builder' },
  'Goods Receipting': { icon: '📦', label: 'Receipting' },
  'Food Safety': { icon: '🌡️', label: 'Food Safety' },
  'Team & Permissions': { icon: '👥', label: 'Team' },
  Ollie: { icon: null, label: 'Ollie' },
}

export function formatCategoryTitle(title) {
  const config = PLAN_FEATURE_CATEGORY_LABELS[title]
  if (!config) {
    return title
  }
  return config.icon ? `${config.icon} ${config.label}` : config.label
}

export const MOST_POPULAR_PLAN = 'Pro'

export function getTeamFeatureGroup(plan) {
  const isFree = plan === 'Free'

  return {
    title: 'Team & Permissions',
    features: isFree
      ? [
          'Invite unlimited team members',
          `Admin, Head Chef / GM, Chef, Order Only, and Kitchen Porter are on ${planDisplayName(
            'Free',
          )}`,
          {
            text: 'Custom roles are on Starter, Growth or Pro',
            limited: true,
          },
        ]
      : [
          'Invite unlimited team members',
          'Role-based access (Admin, Head Chef / GM, Chef, Order Only, Kitchen Porter)',
          'Control who sees GP, invoices, suppliers, and settings',
        ],
  }
}
